import { GridItem } from "commons/ui/Grid";

import FiltersContainer from "components/ui/FiltersContainer";
import SearchInput from "components/ui/SearchInput";

import { MaterialSubcategoryListHook } from "hooks/list/useMaterialSubcategoryList";

function MaterialSubcategoryTableFilters({
    materialSubcategoryListHook,
}: {
    materialSubcategoryListHook: MaterialSubcategoryListHook;
}) {
    const { onSearchFilterChange, filterSearchHook } = materialSubcategoryListHook;

    const { applyFilters, clearFilters, form } = filterSearchHook;

    return (
        <FiltersContainer applyFilters={applyFilters} clearFilters={clearFilters}>
            <GridItem className={"col-xs-12-4"}>
                <SearchInput
                    placeholder={"Cerca"}
                    value={form.search.name}
                    onChange={onSearchFilterChange}
                    filterInput
                />
            </GridItem>
        </FiltersContainer>
    );
}

export default MaterialSubcategoryTableFilters;
